<!-- 由 suu 创建于 2021-01-25 星期一 -->
<template>
  <div class="ability-radar" ref="radar" id="ability-radar"></div>
</template>

<script>
import Highcharts from 'highcharts'
// 极地图 蛛网图需要初始化
import HighchartsMore from 'highcharts/highcharts-more'
HighchartsMore(Highcharts)

export default {
  name: 'ability-radar',

  components: {},

  props: {
    info: {
      type: Object,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.setCoachRadar()
  },

  destroyed() {},

  methods: {
    /**
     * 设置雷达图
     */
    setCoachRadar() {
      let _this = this
      let mySeries = [
        {
          type: 'area',
          showInLegend: false,
          color: '#facddc',
          lineColor: '#dc0050',
          fillOpacity: 0.4,
          lineWidth: 2,
          stacking: 'normal',
          marker: {
            lineWidth: 2,
            lineColor: '#dc0050',
            fillColor: '#fff'
          },
          name: '您的得分',
          data: _this.info.data
          // ,
          // pointPlacement: 'on'
        }
      ]
      // 有平均值则显示
      if (_this.info.average) {
        mySeries[0].showInLegend = true
        mySeries.unshift({
          type: 'area',
          showInLegend: true,
          color: '#e8f2fd',
          lineColor: '#2882e9',
          marker: {
            lineWidth: 2,
            lineColor: '#2882e9',
            fillColor: '#fff'
          },
          name: '健萌er平均得分',
          data: _this.info.average
          // ,
          // pointPlacement: 'on'
        })
      }
      Highcharts.chart(_this.$refs['radar'], {
        chart: {
          polar: true
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        pane: {
          size: '75%',
          endAngle: 360
        },
        xAxis: {
          categories: _this.info.categories,
          tickmarkPlacement: 'on',
          lineWidth: 0,
          color: '#878787',
          labels: {
            y: -10,
            formatter: function () {
              const index = _this.info.categories.findIndex((v) => {
                return v === this.value
              })
              const num = _this.info.data[index]
              const change = _this.info.change[index]
              let average = ''
              // if (_this.info.average) {
              //   average = _this.info.average[index]
              // }
              return (
                `${this.value} <br/> <span style="font-weight: 800; font-size: 3.3vw; color: #000">${num}</span>分` +
                (average
                  ? ` (<span style="color: #2882e9">${average}</span>)`
                  : '') +
                (change
                  ? `<br/> <span style="color: ${
                      change < 0 ? '#2882e9' : '#dc0050'
                    }; font-size: 2.7vw;">${
                      change >= 0 ? '+' + change : change
                    }分</span>`
                  : '')
              )
            }
          }
        },
        yAxis: {
          // gridLineInterpolation: 'polygon',
          lineWidth: 0,
          min: 0,
          // max: 105,
          tickInterval: 25, // 设置刻度间隔
          labels: {
            formatter: function () {
              // return this.value + '';
              return ''
            }
          }
        },
        plotOptions: {
          // area: {
          //   // dataLabels: {
          //   //   enabled: true
          //   // },
          //   stacking: "normal",
          //   lineColor: "#dc0050",
          //   lineWidth: 2,
          //   marker: {
          //     lineWidth: 2,
          //     lineColor: "#dc0050",
          //     fillColor: "#fff"
          //   }
          // },
          // line: {
          //   // dataLabels: {
          //   //   enabled: true
          //   // },
          //   stacking: "normal",
          //   lineColor: "#2882e9",
          //   lineWidth: 2,
          //   marker: {
          //     lineWidth: 2,
          //     lineColor: "#2882e9",
          //     fillColor: "#fff"
          //   }
          // }
        },
        // tooltip: {
        //   shared: true,
        //   // eslint-disable-next-line
        //   pointFormat: '<span style="color:{series.color}">{series.name}: <b>${point.y:,.0f}</b><br/>'
        // },
        series: mySeries
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ability-radar {
}
#ability-radar {
  width: 100%;
  box-sizing: border-box;
  height: 43vh;
  margin: 0 auto;
}
</style>
<style>
.highcharts-credits {
  display: none !important;
}
</style>
